export const formatClientSearchInput = request => {
	return {
		clientFirstName: request.clientFirstName,
		clientLastName: request.clientLastName,
		clientPhone: request.clientPhone,
	};
};
